import { FC, useEffect, useState } from "react";
import SettingService, {
  SettingsSections,
  vouchersSettings,
} from "../../../Services/SettingService";
import {
  actionTypeAll,
  actionTypeCRED,
  actionTypeViewAndEdit,
  dashboardTabs,
  IAllUserPermissionsData,
  IPermission,
  IPermissionActionType,
  IPermissionTableColumnType,
  masterTabs,
  reportTabs,
  settingCompanyTabs,
  settingCurrenciesTabs,
  settingDefaultLedgeTabs,
  settingEmailTabs,
  settingItemsTabs,
  settingLockMonthTabs,
  settingOpeningBalanceTabs,
  settingTCSTabs,
  settingTDSTabs,
  settingTemplatesTabs,
} from "./UserPermissionCommonData";
import {
  Button,
  Checkbox,
  Col,
  Drawer,
  DrawerProps,
  Form,
  Input,
  notification,
  Row,
  Space,
  Spin,
  Table,
  Tabs,
  TabsProps,
  Tag,
  Tooltip,
  Typography,
} from "antd";
import { CloseOutlined, LoadingOutlined } from "@ant-design/icons";
import { useTheme } from "../../../Context/ThemeContext";
import { ColumnsType } from "antd/es/table";
import TextArea from "antd/es/input/TextArea";
import ClientRoleServices from "../../../Services/ClientRoleServices";
import { IIsClientSpecificRoleVouchersData } from "../../../../Context/RoleContext";
import { useHotkey } from "../../../Context/HotKeyContext";
import EntryLevelKeys from "../../../Common/EntryLevelKeys";

const AddClientRoles: FC<{
  open: boolean;
  onCancel: any;
  clientId: string;
  drawerPlacement: DrawerProps["placement"];
  newClientRoleIndex?: number;
  setTrigger?: any;
  setAddNewClientRole?: any;
  id?: string;
  itemPage?: any;
  isServicesItem?: boolean;
}> = (props) => {
  console.log("login", props);

  const { showKeys } = useHotkey();
  const [voucherTabsData, setVoucherTabsData] = useState<
    IAllUserPermissionsData[]
  >([]);
  const [settingTermsAndConditionsData, setSettingTermsAndConditionsData] =
    useState<IAllUserPermissionsData[]>([]);
  const [settingVoucherData, setSettingVoucherData] = useState<
    IAllUserPermissionsData[]
  >([]);
  const [isEditTrigger, setIsEditTrigger] = useState<boolean>(false);

  const allClientPermissionsData = [
    ...dashboardTabs,
    ...voucherTabsData,
    // Report Tabs
    ...reportTabs,
    // Master Tabs
    ...masterTabs,
    // Setting Tabs
    ...settingCompanyTabs,

    ...settingVoucherData,

    ...settingItemsTabs,
    ...settingOpeningBalanceTabs,
    ...settingTemplatesTabs,
    ...settingDefaultLedgeTabs,

    ...settingTermsAndConditionsData,

    ...settingTDSTabs,
    ...settingTCSTabs,
    ...settingCurrenciesTabs,
    ...settingEmailTabs,
    ...settingLockMonthTabs,
  ];

  useEffect(() => {
    if (props?.clientId) {
      setDrawerLoading(true);
      const voucherNameList = async () => {
        try {
          const data = await SettingService.getVoucherNameListSetting(
            props?.clientId!
          );

          const allVoucherName: vouchersSettings[] =
            data.result?.vouchersSettings.map((x: any) => {
              return {
                ...x,
                id: x._id,
              };
            });

          if (allVoucherName?.length > 0) {
            const voucherWiseData = ClientVoucherTabs(allVoucherName);

            const settingTC = ClientSettingTermAndConditionTabs(allVoucherName);
            const settingVouchers = ClientSettingVoucherTabs(allVoucherName);

            if (
              voucherWiseData?.length > 0 &&
              settingTC?.length > 0 &&
              settingVouchers?.length > 0
            ) {
              // const voucher = ;
              // const settingVoucher = ;
              // const settingTC = ;

              setVoucherTabsData(allClientRolesVouchers(voucherWiseData));

              setSettingVoucherData(
                allClientRoleSettingVoucher(settingVouchers)
              );
              setSettingTermsAndConditionsData(
                allClientRoleSettingTC(settingTC)
              );
              setIsEditTrigger(true);

              // console.log(
              //   "x",
              //   voucher,
              //   "settingTC",
              //   settingTC,
              //   "settingVouchers",
              //   settingVouchers
              // );
            }
          }
        } catch (ex: any) {
          console.error("error", ex);
          notification.success({
            message: "Error",
            description: ex || "An error occurred while saving.",
          });
        } finally {
          !props.id && setDrawerLoading(false);
        }
      };

      voucherNameList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props?.clientId]);

  useEffect(() => {
    if (props.id && isEditTrigger) {
      const getRoleData = async () => {
        setDrawerLoading(true);
        await ClientRoleServices.getRoleById(props.clientId, props?.id)
          .then((res) => {
            if (res?.status) {
              // console.log("res.resulttt", res.result);
              const data = res?.result;

              form.setFieldsValue({
                ...data,
                title: data.title,
                description: data.description,
              });
              setPermissions(data?.accessSettings);
            } else {
              console.log(res);
            }
          })
          .catch((ex) => {
            console.log(ex);
          })
          .finally(() => {
            setDrawerLoading(false);
          });
      };
      getRoleData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.id, isEditTrigger]);

  const [form] = Form.useForm();
  const [permissions, setPermissions] = useState<string[]>([]);
  const [isPermissionErr, setIsPermissionErr] = useState(false);
  const [drawerLoading, setDrawerLoading] = useState(false);
  const [saveButtonLoading, setSaveButtonLoading] = useState<boolean>(false);

  const { themeData } = useTheme();
  const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;

  console.log("allClientPermissionsData", permissions);

  const onClose = (postData: any) => {
    props?.setAddNewClientRole({
      roleId: postData?.result?.id,
      roleName: postData?.result?.name,
    });
    props.setTrigger((x: any) => !x);
    props.onCancel();
    setIsPermissionErr(false);
    form.resetFields();
    setPermissions([]);
  };

  const addClientPermission = () => {
    try {
      form.validateFields().then(async (val) => {
        let userPermission = {
          ...val,
          accessSettings: permissions,
        };
        if (permissions?.length > 0) {
          setSaveButtonLoading(true);
          setIsPermissionErr(false);
          const postData = await ClientRoleServices.postClientRole(
            props.clientId,
            userPermission,
            props?.id
          );
          console.log("postData", postData);
          if (postData.status) {
            onClose(postData);
            notification.success({
              message: `Role ${props.id ? "updated" : "saved"} successfully`,
            });
          } else {
            notification.error({
              message: `${postData.message}`,
            });
          }
        } else {
          setIsPermissionErr(true);
        }
      });
    } catch (error: any) {
      notification.success({
        message: "Error",
        description: error || "An error occurred while saving.",
      });
      setIsPermissionErr(permissions?.length > 0 ? false : true);
    } finally {
      setSaveButtonLoading(false);
    }
  };

  const getTableColumns = (
    type: IPermissionTableColumnType
  ): ColumnsType<IPermission> => {
    let columns: ColumnsType<IPermission> = [
      {
        title: "S.No.",
        key: "sno",
        width: "70px",
        render: (_, record, index) => <span>{index + 1}</span>,
      },
      {
        title: "Feature",
        key: "feature",
        ellipsis: { showTitle: false },
        render: (_, record) => (
          <Row align="middle" wrap={false}>
            {/* {type !== IPermissionTableColumnType.View && ( */}
            <Col flex="24px">
              <Checkbox
                checked={record?.actionType
                  ?.map((itm) => `${record?.featureValue}.${itm}`)
                  ?.every((s) => permissions.includes(s))}
                onChange={(e) =>
                  onChange(
                    "featureModule",
                    e.target.checked,
                    null,
                    record,
                    null
                  )
                }
              ></Checkbox>
            </Col>
            {/* )} */}
            <Col flex="auto">
              <Typography.Text ellipsis={{ tooltip: true }}>
                {record?.feature}
              </Typography.Text>
            </Col>
          </Row>
        ),
      },
      {
        title: "View",
        key: "view",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.View) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.View}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.View
                )
              }
            ></Checkbox>
          ) : null,
      },
    ];

    if (
      type === IPermissionTableColumnType.ViewCreate ||
      type === IPermissionTableColumnType.CRED ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Add",
        key: "add",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Add) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Add}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Add
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.ViewUpdate ||
      type === IPermissionTableColumnType.CRED ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Edit",
        key: "edit",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Edit) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Edit}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Edit
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.All ||
      type === IPermissionTableColumnType.CRED
    ) {
      columns.push({
        title: "Delete",
        key: "delete",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Delete) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Delete}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Delete
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.Print ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Print",
        key: "print",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Print) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Print}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Print
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    if (
      type === IPermissionTableColumnType.Authorize ||
      type === IPermissionTableColumnType.All
    ) {
      columns.push({
        title: "Authorize",
        key: "authorize",
        width: "85px",
        align: "center",
        render: (_, record) =>
          record?.actionType?.includes(IPermissionActionType.Authorize) ? (
            <Checkbox
              checked={permissions?.includes(
                `${record?.featureValue}.${IPermissionActionType.Authorize}`
              )}
              onChange={(e) =>
                onChange(
                  "feature",
                  e.target.checked,
                  null,
                  record,
                  IPermissionActionType.Authorize
                )
              }
            ></Checkbox>
          ) : null,
      });
    }

    return columns;
  };

  const onChange = (
    type: "allFeature" | "module" | "featureModule" | "feature",
    isChecked: boolean,
    module: string | null,
    record: IPermission | null,
    permissionType: string | null
  ) => {
    let data: any = permissions;

    switch (type) {
      case "allFeature":
        data = [];
        if (isChecked) {
          for (let i = 0; i <= allClientPermissionsData?.length - 1; i++) {
            data.push(
              allClientPermissionsData[i]?.permissions
                ?.map((itm) => {
                  return itm.actionType.map(
                    (action) => `${itm.featureValue}.${action}`
                  );
                })
                .flat()
            );
          }
          data = data?.flat();
        }

        break;

      case "module":
        let modulePermission = allClientPermissionsData
          ?.find((itm) => itm?.module === module)
          ?.permissions?.map((itm) => {
            return itm.actionType.map(
              (action) => `${itm.featureValue}.${action}`
            );
          })
          .flat();

        if (modulePermission?.length && modulePermission?.length > 0) {
          data.push(modulePermission?.flat()?.map((itm) => itm));
          data = data?.flat();
        }
        if (!isChecked)
          data = data?.filter((itm: any) => !modulePermission?.includes(itm));

        break;

      case "featureModule":
        let featurePermission = record?.actionType?.map(
          (itm) => `${record?.featureValue}.${itm}`
        );
        if (isChecked) {
          // if (!data?.includes(`${record?.module}.View`)) {
          //   data.push(`${record?.module}.View`);
          // }
          data.push(featurePermission?.map((itm) => itm));

          data = data?.flat();
        } else {
          data = data?.filter(
            (item: any) => !featurePermission?.includes(item)
          );
          // if (!data?.includes(`${record?.module}.View`)) {
          let modulePermission = allClientPermissionsData
            ?.find((itm) => itm?.module === record?.module)
            ?.permissions?.map((itm) => {
              return itm.actionType.map(
                (action) => `${itm.featureValue}.${action}`
              );
            })
            .flat();

          if (modulePermission?.length && modulePermission?.length > 0) {
            data = data?.filter((itm: any) => !modulePermission?.includes(itm));
          }
          // }
        }

        break;

      case "feature":
        // debugger
        var item = `${record?.featureValue}.${permissionType}`;

        // var moduleViewPermission = `${record?.module}.View`;
        // console.log("moduleViewPermission", moduleViewPermission);

        var viewPermission = `${record?.featureValue}.View`;
        // console.log("viewPermission", viewPermission);
        var otherPermission = [
          `${record?.featureValue}.Add`,
          `${record?.featureValue}.Edit`,
          `${record?.featureValue}.Delete`,
          `${record?.featureValue}.Print`,
          `${record?.featureValue}.Authorize`,
        ];
        // console.log("otherPermission", otherPermission);

        if (isChecked) {
          // console.log("permissions", permissions);
          // if (!permissions?.includes(moduleViewPermission))
          //   data.push(moduleViewPermission);

          if (
            // moduleViewPermission !== viewPermission &&
            !permissions?.includes(viewPermission)
          )
            data.push(viewPermission);
          // item !== moduleViewPermission &&
          if (item !== viewPermission) data.push(item);
        } else {
          if (item === viewPermission) {
            otherPermission.push(viewPermission);
            data = data?.filter(
              (element: any) => !otherPermission.includes(element)
            );
          } else {
            if (
              data?.find((itm: any) => itm?.split(".")[0] === record?.module) ||
              data?.find((itm: any) => itm?.split(".")[1] === record?.module)
            )
              data = data?.filter((i: any) => i !== item);
          }
          if (item === viewPermission) {
            let modulePermission = allClientPermissionsData
              ?.find((itm) => itm?.module === record?.module)
              ?.permissions?.map((itm) => {
                return itm.actionType.map(
                  (action) => `${itm.featureValue}.${action}`
                );
              })
              .flat();

            if (modulePermission?.length && modulePermission?.length > 0) {
              data = data?.filter(
                (itm: any) => !modulePermission?.includes(itm)
              );
            }
          }
        }

        break;
    }

    data = data?.filter(
      (value: any, index: number, self: any) => self.indexOf(value) === index
    );
    setPermissions(data);
    setIsPermissionErr(data?.length > 0 ? false : true);
  };

  const isSelectAllPemissions = () => {
    let totalPermission = 0;
    for (let i = 0; i <= allClientPermissionsData?.length - 1; i++) {
      totalPermission += allClientPermissionsData[i]?.permissions
        ?.map((itm) => {
          return itm.actionType.map(
            (action) => `${itm.featureValue}.${action}`
          );
        })
        .flat()?.length;
    }

    return permissions?.length > 0 && totalPermission === permissions?.length;
  };

  const isModuleSelectAll = (module: string) => {
    let data: any = [];
    let modulePermission = allClientPermissionsData?.find(
      (itm) => itm?.module === module
    );
    if (modulePermission) {
      data.push(
        modulePermission?.permissions
          ?.map((itm) => {
            return itm.actionType.map(
              (action) => `${itm.featureValue}.${action}`
            );
          })
          .flat()
      );
    }
    data = data?.flat();

    return (
      permissions?.length > 0 &&
      data?.every((d: string) => permissions?.includes(d))
    );
  };

  console.log("premission", permissions);

  const tabsItems: TabsProps["items"] = [
    {
      key: "1",
      label: "Dashboard",
      children: (
        <div>
          {allClientPermissionsData?.slice(0, 1)?.map((itm, idx: number) => (
            <div className="mb-2">
              <Row justify="space-between" align="middle">
                <Col className="fs-14">{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "2",
      label: "Voucher",
      children: (
        <div>
          {allClientPermissionsData?.slice(1, 8)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "3",
      label: "Report",
      children: (
        <div>
          {allClientPermissionsData?.slice(8, 9)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "4",
      label: "Master",
      children: (
        <div>
          {allClientPermissionsData?.slice(9, 17)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
    {
      key: "5",
      label: "Setting",
      children: (
        <div>
          {allClientPermissionsData?.slice(17, 32)?.map((itm, idx: number) => (
            <div style={{ paddingBottom: "20px" }}>
              <Row justify="space-between" align="middle">
                <Col>{itm?.module}</Col>
                <Checkbox
                  style={{ fontWeight: 400 }}
                  checked={isModuleSelectAll(itm?.module)}
                  onChange={(e) =>
                    onChange(
                      "module",
                      e.target.checked,
                      itm?.module,
                      null,
                      null
                    )
                  }
                >
                  Select All
                </Checkbox>
              </Row>

              <Table
                scroll={{ x: 500 }}
                columns={getTableColumns(itm?.columnsType)}
                dataSource={itm?.permissions}
                className={`Tabel-style table-${
                  themeData?.componentSize ?? "middle"
                }`}
                pagination={false}
              />
            </div>
          ))}
        </div>
      ),
    },
  ];

  EntryLevelKeys({
    save: () => addClientPermission(),
    cancel: () => props.onCancel(false),
  });

  return (
    <Drawer
      maskClosable={false}
      open={props.open}
      title={props?.id ? "Edit Client Role" : "Add Client Role"}
      width={950}
      closable={false}
      extra={
        <Space>
          <CloseOutlined onClick={() => props.onCancel()} />
        </Space>
      }
      placement={props?.drawerPlacement}
      footer={
        <div style={{ marginTop: "0px" }}>
          <Space
            style={{
              display: "flex",
              justifyContent: "end",
              marginRight: 20,
            }}
          >
            <Tooltip
              title={<p>ALT+C</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                onClick={() => {
                  props.onCancel();
                }}
              >
                Cancel
              </Button>
            </Tooltip>

            <Tooltip
              title={<p>ALT+S</p>}
              placement="bottomLeft"
              open={showKeys}
            >
              <Button
                type="primary"
                onClick={() => addClientPermission()}
                loading={saveButtonLoading}
                // style={{marginLeft:"10px"}}
              >
                {!props?.id ? "Save" : "Update"}
              </Button>
            </Tooltip>
          </Space>
        </div>
      }
      className="ledgerdrawerstyle"
    >
      <Spin indicator={antIcon} spinning={drawerLoading}>
        <Form
          form={form}
          name="rolePermission"
          labelAlign="left"
          labelCol={{ xs: 8, sm: 6 }}
          wrapperCol={{ xs: 16, sm: 18 }}
          colon={false}
          autoComplete="off"
          requiredMark={true}
        >
          <Row gutter={[8, 8]}>
            <Col xs={24} md={18} lg={12} xl={12}>
              <Form.Item
                label="Role"
                name="name"
                rules={[
                  { required: true, message: "This field is required" },
                  // { validator: Utils.validateWhiteSpace },
                ]}
                className="input-item"
              >
                <Input
                  placeholder="Enter role"
                  onKeyPress={(e) =>
                    !/[A-Za-z\s]/.test(e.key) && e.preventDefault()
                  }
                />
              </Form.Item>
              <Form.Item
                label="Description"
                name="description"
                className="input-item"
              >
                <TextArea
                  autoSize={{ minRows: 2, maxRows: 6 }}
                  placeholder="Enter role description"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row
            align="middle"
            justify="space-between"
            style={{
              backgroundColor: "#f4f5fa",
              margin: "0px -24px 0px -24px",
              padding: "8px 24px",
              minHeight: 33,
            }}
            className="fw-500"
          >
            <Col className="theme-color">
              <Row align="middle">
                <Col
                  className="fs-14 fw-600 me-2"
                  style={{ paddingRight: "10px" }}
                >
                  Permissions
                </Col>
                {isPermissionErr && (
                  <Tag color="error">Please choose at least one permission</Tag>
                )}
              </Row>
            </Col>
            <Checkbox
              style={{ fontWeight: 400 }}
              checked={isSelectAllPemissions()}
              onChange={(e) =>
                onChange("allFeature", e.target.checked, null, null, null)
              }
            >
              Select All
            </Checkbox>
          </Row>

          <div
            style={{ maxHeight: "calc(100vh - 300px)", overflow: "auto" }}
            className="custom-scroll"
          >
            <Tabs className="no-margin-left" items={tabsItems} />
          </div>
        </Form>
      </Spin>
    </Drawer>
  );
};

export default AddClientRoles;

export const allClientRolesVouchers = (customerWiseVoucher: any) => {
  return [
    {
      module: "Sales Vouchers",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[0],
      // salesVouchersPermissions,
    },
    {
      module: "Purchase Vouchers",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[1],
    },
    {
      module: "Expenses",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[2],
    },
    {
      module: "Income",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[3],
    },
    {
      module: "Contra",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[4],
    },
    {
      module: "Journal",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[5],
    },
    {
      module: "Fixed Assets",
      columnsType: IPermissionTableColumnType.All,
      permissions: customerWiseVoucher[6],
    },
  ];
};

export const allClientRoleSettingVoucher = (
  customerWiseSettingVoucher: any
) => {
  return [
    {
      module: "Vouchers Setting",
      columnsType: IPermissionTableColumnType.CRED,
      permissions: customerWiseSettingVoucher,
    },
  ];
};

export const allClientRoleSettingTC = (customerWiseSettingTC: any) => {
  return [
    {
      module: "Terms And Conditions",
      columnsType: IPermissionTableColumnType.CRED,
      permissions: customerWiseSettingTC,
    },
  ];
};

export const findVouchars = (
  result: vouchersSettings[],
  type: SettingsSections
) => {
  const filterVouchers = result?.filter((x: any) => x.settingType === type);
  // console.log("salesVoucher", filterVouchers);
  return filterVouchers;
};

// Voucher Tabs
export const ClientVoucherTabs = (result: any) => {
  // Sales Vouchers
  const salesVoucher = findVouchars(result, SettingsSections.Invoice)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Sales",
        feature: x.title,
        featureValue: `Voucher.Sales.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const proformaInvoice = findVouchars(result, SettingsSections.PInvoice)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Sales",
        feature: x.title,
        featureValue: `Voucher.Sales.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const creditNote = findVouchars(result, SettingsSections.CrNote)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Sales",
        feature: x.title,
        featureValue: `Voucher.Sales.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const receipt = findVouchars(result, SettingsSections.Receipt)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Sales",
        feature: x.title,
        featureValue: `Voucher.Sales.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const estimate = findVouchars(result, SettingsSections.Quotation)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Sales",
        feature: x.title,
        featureValue: `Voucher.Sales.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const salesOrder = findVouchars(result, SettingsSections.SOrder)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Sales",
        feature: x.title,
        featureValue: `Voucher.Sales.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  // Purchase Vouchers
  const purchaseVoucher = findVouchars(
    result,
    SettingsSections.PurInvoice
  )?.map((x: vouchersSettings) => {
    return {
      module: "Purchase",
      feature: x.title,
      featureValue: `Voucher.Purchase.${x.id}`,
      actionType: actionTypeAll,
    };
  });

  const debitNote = findVouchars(result, SettingsSections.DrNote)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Purchase",
        feature: x.title,
        featureValue: `Voucher.Purchase.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const paymentOut = findVouchars(result, SettingsSections.Payment)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Purchase",
        feature: x.title,
        featureValue: `Voucher.Purchase.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  const purchaseOrder = findVouchars(result, SettingsSections.POrder)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Purchase",
        feature: x.title,
        featureValue: `Voucher.Purchase.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  // Expenses Vouchars
  const expenses = findVouchars(result, SettingsSections.Expenses)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Expenses",
        feature: x.title,
        featureValue: `Voucher.Expenses.14.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  // Income Vouchars
  const income = findVouchars(result, SettingsSections.Income)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Income",
        feature: x.title,
        featureValue: `Voucher.Income.15.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  // Contra Vouchars

  const contra = findVouchars(result, SettingsSections.Contra)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Contra",
        feature: x.title,
        featureValue: `Voucher.Contra.13.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );
  // Journal Vouchars
  const journal = findVouchars(result, SettingsSections.Journal)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Journal",
        feature: x.title,
        featureValue: `Voucher.Journal.12.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );

  // Asset Vouchars

  const fixedAsset = findVouchars(result, SettingsSections.Asset)?.map(
    (x: vouchersSettings) => {
      return {
        module: "FixedAsset",
        feature: x.title,
        featureValue: `Voucher.Asset.11.${x.id}`,
        actionType: actionTypeAll,
      };
    }
  );
  const allSales = [
    ...salesVoucher,
    ...proformaInvoice,
    ...creditNote,
    ...receipt,
    ...estimate,
    ...salesOrder,
  ];

  const allPurchase = [
    ...purchaseVoucher,
    ...debitNote,
    ...paymentOut,
    ...purchaseOrder,
  ];
  // console.log(
  //   "data",
  //   allSales,
  //   allPurchase,
  //   expenses,
  //   income,
  //   contra,
  //   journal,
  //   fixedAsset
  // );
  return [allSales, allPurchase, expenses, income, contra, journal, fixedAsset];
};

// Setting Term And Condition Tabs
export const ClientSettingTermAndConditionTabs = (result: any) => {
  // const featureValue = (title: string) => {
  //   return isVoucher ? `Setting.Voucher.${title}` : '';
  // };

  // Sales Vouchers
  const salesVoucher = findVouchars(result, SettingsSections.Invoice)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const proformaInvoice = findVouchars(result, SettingsSections.PInvoice)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const creditNote = findVouchars(result, SettingsSections.CrNote)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const receipt = findVouchars(result, SettingsSections.Receipt)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const estimate = findVouchars(result, SettingsSections.Quotation)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const salesOrder = findVouchars(result, SettingsSections.SOrder)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  // Purchase Vouchers
  const purchaseVoucher = findVouchars(
    result,
    SettingsSections.PurInvoice
  )?.map((x: vouchersSettings) => {
    return {
      module: "Setting",
      feature: x.title,
      featureValue: `Setting.TC.${x.id}`,
      actionType: actionTypeCRED,
    };
  });

  const debitNote = findVouchars(result, SettingsSections.DrNote)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const paymentOut = findVouchars(result, SettingsSections.Payment)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const purchaseOrder = findVouchars(result, SettingsSections.POrder)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  // Expenses Vouchars
  const expenses = findVouchars(result, SettingsSections.Expenses)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  // Income Vouchars
  const income = findVouchars(result, SettingsSections.Income)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  // Contra Vouchars

  const contra = findVouchars(result, SettingsSections.Contra)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );
  // Journal Vouchars
  const journal = findVouchars(result, SettingsSections.Journal)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  // Asset Vouchars

  const fixedAsset = findVouchars(result, SettingsSections.Asset)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.TC.${x.id}`,
        actionType: actionTypeCRED,
      };
    }
  );

  const allSales = [
    ...salesVoucher,
    ...proformaInvoice,
    ...creditNote,
    ...receipt,
    ...estimate,
    ...salesOrder,
  ];

  const allPurchase = [
    ...purchaseVoucher,
    ...debitNote,
    ...paymentOut,
    ...purchaseOrder,
  ];
  // console.log(
  //   "data",
  //   allSales,
  //   allPurchase,
  //   expenses,
  //   income,
  //   contra,
  //   journal,
  //   fixedAsset
  // );
  return [
    ...allSales,
    ...allPurchase,
    ...expenses,
    ...income,
    ...contra,
    ...journal,
    ...fixedAsset,
  ];
};

// Setting Voucher Tabs
export const ClientSettingVoucherTabs = (result: any) => {
  // const featureValue = (title: string) => {
  //   return isVoucher ? `Setting.Voucher.${title}` : '';
  // };

  // Sales Vouchers
  const salesVoucher = findVouchars(result, SettingsSections.Invoice)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  const proformaInvoice = findVouchars(result, SettingsSections.PInvoice)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  const creditNote = findVouchars(result, SettingsSections.CrNote)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );

  const receipt = findVouchars(result, SettingsSections.Receipt)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );

  const estimate = findVouchars(result, SettingsSections.Quotation)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  const salesOrder = findVouchars(result, SettingsSections.SOrder)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  // Purchase Vouchers
  const purchaseVoucher = findVouchars(
    result,
    SettingsSections.PurInvoice
  )?.map((x: vouchersSettings) => {
    return {
      module: "Setting",
      feature: x.title,
      featureValue: `Setting.Voucher.${x.id}`,
      actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
    };
  });

  const debitNote = findVouchars(result, SettingsSections.DrNote)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );

  const paymentOut = findVouchars(result, SettingsSections.Payment)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );

  const purchaseOrder = findVouchars(result, SettingsSections.POrder)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  // Expenses Vouchars
  const expenses = findVouchars(result, SettingsSections.Expenses)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  // Income Vouchars
  const income = findVouchars(result, SettingsSections.Income)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: x?.system ? actionTypeCRED : actionTypeViewAndEdit,
      };
    }
  );

  // Contra Vouchars

  const contra = findVouchars(result, SettingsSections.Contra)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );
  // Journal Vouchars
  const journal = findVouchars(result, SettingsSections.Journal)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );

  // Asset Vouchars

  const fixedAsset = findVouchars(result, SettingsSections.Asset)?.map(
    (x: vouchersSettings) => {
      return {
        module: "Setting",
        feature: x.title,
        featureValue: `Setting.Voucher.${x.id}`,
        actionType: actionTypeViewAndEdit,
      };
    }
  );
  const allSales = [
    ...salesVoucher,
    ...proformaInvoice,
    ...creditNote,
    ...receipt,
    ...estimate,
    ...salesOrder,
  ];

  const allPurchase = [
    ...purchaseVoucher,
    ...debitNote,
    ...paymentOut,
    ...purchaseOrder,
  ];
  // console.log(
  //   "data",
  //   allSales,
  //   allPurchase,
  //   expenses,
  //   income,
  //   contra,
  //   journal,
  //   fixedAsset
  // );
  return [
    ...allSales,
    ...allPurchase,
    ...expenses,
    ...income,
    ...contra,
    ...journal,
    ...fixedAsset,
  ];
};

export const clientSpecifxRoleVoucherName = (
  result: any
): IIsClientSpecificRoleVouchersData[] =>
  Object.values(
    result?.vouchersSettings?.reduce(
      (
        acc: Record<SettingsSections, IIsClientSpecificRoleVouchersData>,
        x: any
      ) => {
        const type: SettingsSections = x.settingType;

        if (!acc[type]) {
          acc[type] = {
            type,
            data: {
              Vouchers: {
                Add: [],
                Edit: [],
                View: [],
                Delete: [],
                Print: [],
                Authorize: [],
              },
              Setting: {
                Add: [],
                Delete: [],
                Edit: [],
                View: [],
              },
              TandC: {
                Add: [],
                Edit: [],
                View: [],
                Delete: [],
              },
            },
          };
        }

        const permissions = acc[type].data;

        switch (type) {
          // Sales Vouchers
          case SettingsSections.Invoice:
          case SettingsSections.PInvoice:
          case SettingsSections.CrNote:
          case SettingsSections.Receipt:
          case SettingsSections.Quotation:
          case SettingsSections.SOrder:
            permissions.Vouchers.Add?.push(`Voucher.Sales.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Sales.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Sales.${x._id}.View`);
            permissions.Vouchers.Delete?.push(`Voucher.Sales.${x._id}.Delete`);
            permissions?.Vouchers?.Print?.push(`Voucher.Sales.${x._id}.Print`);
            permissions?.Vouchers?.Authorize?.push(
              `Voucher.Sales.${x._id}.Authorize`
            );
            break;

          // Purchase Vouchers
          case SettingsSections.PurInvoice:
          case SettingsSections.DrNote:
          case SettingsSections.Payment:
          case SettingsSections.POrder:
            permissions.Vouchers.Add?.push(`Voucher.Purchase.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Purchase.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Purchase.${x._id}.View`);
            permissions.Vouchers.Delete?.push(
              `Voucher.Purchase.${x._id}.Delete`
            );
            permissions.Vouchers.Print?.push(`Voucher.Purchase.${x._id}.Print`);
            permissions.Vouchers.Authorize?.push(
              `Voucher.Purchase.${x._id}.Authorize`
            );
            break;

          // Other Vouchers
          case SettingsSections.Expenses:
            permissions.Vouchers.Add?.push(`Voucher.Expenses.14.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Expenses.14.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Expenses.14.${x._id}.View`);
            permissions.Vouchers.Delete?.push(
              `Voucher.Expenses.14.${x._id}.Delete`
            );
            permissions.Vouchers.Print?.push(
              `Voucher.Expenses.14.${x._id}.Print`
            );
            permissions.Vouchers.Authorize?.push(
              `Voucher.Expenses.14.${x._id}.Authorize`
            );
            break;

          case SettingsSections.Income:
            permissions.Vouchers.Add?.push(`Voucher.Income.15.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Income.15.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Income.15.${x._id}.View`);
            permissions.Vouchers.Delete?.push(
              `Voucher.Income.15.${x._id}.Delete`
            );
            permissions.Vouchers.Print?.push(
              `Voucher.Income.15.${x._id}.Print`
            );
            permissions.Vouchers.Authorize?.push(
              `Voucher.Income.15.${x._id}.Authorize`
            );
            break;

          case SettingsSections.Contra:
            permissions.Vouchers.Add?.push(`Voucher.Contra.13.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Contra.13.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Contra.13.${x._id}.View`);
            permissions.Vouchers.Delete?.push(
              `Voucher.Contra.13.${x._id}.Delete`
            );
            permissions.Vouchers.Print?.push(
              `Voucher.Contra.13.${x._id}.Print`
            );
            permissions.Vouchers.Authorize?.push(
              `Voucher.Contra.13.${x._id}.Authorize`
            );
            break;

          case SettingsSections.Journal:
            permissions.Vouchers.Add?.push(`Voucher.Journal.12.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Journal.12.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Journal.12.${x._id}.View`);
            permissions.Vouchers.Delete?.push(
              `Voucher.Journal.12.${x._id}.Delete`
            );
            permissions.Vouchers.Print?.push(
              `Voucher.Journal.12.${x._id}.Print`
            );
            permissions.Vouchers.Authorize?.push(
              `Voucher.Journal.12.${x._id}.Authorize`
            );
            break;

          case SettingsSections.Asset:
            permissions.Vouchers.Add?.push(`Voucher.Asset.11.${x._id}.Add`);
            permissions.Vouchers.Edit.push(`Voucher.Asset.11.${x._id}.Edit`);
            permissions.Vouchers.View.push(`Voucher.Asset.11.${x._id}.View`);
            permissions.Vouchers.Delete?.push(
              `Voucher.Asset.11.${x._id}.Delete`
            );
            permissions.Vouchers.Print?.push(`Voucher.Asset.11.${x._id}.Print`);
            permissions.Vouchers.Authorize?.push(
              `Voucher.Asset.11.${x._id}.Authorize`
            );
            break;

          default:
            break;
        }

        // setting type
        switch (type) {
          // Sales Vouchers
          case SettingsSections.Invoice:
          case SettingsSections.PInvoice:
          case SettingsSections.Quotation:
          case SettingsSections.SOrder:
          case SettingsSections.PurInvoice:
          case SettingsSections.POrder:
          case SettingsSections.Expenses:
          case SettingsSections.Income:
            permissions.Setting.Edit.push(`Setting.Voucher.${x._id}.Edit`);
            permissions.Setting.View.push(`Setting.Voucher.${x._id}.View`);
            permissions.Setting.Add?.push(`Setting.Voucher.${x._id}.Add`);
            permissions.Setting.Delete?.push(`Setting.Voucher.${x._id}.Delete`);

            break;

          case SettingsSections.CrNote:
          case SettingsSections.Receipt:
          case SettingsSections.DrNote:
          case SettingsSections.Payment:
          case SettingsSections.Contra:
          case SettingsSections.Journal:
          case SettingsSections.Asset:
            permissions.Setting.View.push(`Setting.Voucher.${x._id}.View`);
            permissions.Setting.Edit.push(`Setting.Voucher.${x._id}.Edit`);
            break;

          default:
            break;
        }

        // Tern and Condition type
        switch (type) {
          // Sales Vouchers
          case SettingsSections.Invoice:
          case SettingsSections.PInvoice:
          case SettingsSections.Quotation:
          case SettingsSections.SOrder:
          case SettingsSections.CrNote:
          case SettingsSections.Receipt:
          case SettingsSections.PurInvoice:
          case SettingsSections.POrder:
          case SettingsSections.DrNote:
          case SettingsSections.Payment:
          case SettingsSections.Expenses:
          case SettingsSections.Income:
          case SettingsSections.Contra:
          case SettingsSections.Journal:
          case SettingsSections.Asset:
            permissions.TandC.Add?.push(`Setting.TC.${x._id}.Add`);
            permissions.TandC.Delete?.push(`Setting.TC.${x._id}.Delete`);
            permissions.TandC.Edit.push(`Setting.TC.${x._id}.Edit`);
            permissions.TandC.View.push(`Setting.TC.${x._id}.View`);
            break;

          default:
            break;
        }

        return acc;
      },
      {} as Record<SettingsSections, IIsClientSpecificRoleVouchersData>
    )
  );
